import React, { useEffect, useState } from 'react';
import { Col, Button, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from 'lodash';
import { ItemDropdownMenu, Pager, SortHeader } from ".";
import { api, constants, dateHelpers } from '../utils';

export default function CorrrectiveActionsGrid(props) {
   const actionStatuses = {
      1: "Open",
      2: "Closed",
      3: "Awaiting Follow Up",
      4: "Pending",
      5: "Canceled"
   };
   const actionTypes = {
      1: "Corrective Action",
      2: "Preventative Action",
      3: "Supplier Corrective Action",
      4: "Internal Corrective Action"
   };
   const [data, setData] = useState();
   const [downLoading, setDownLoading] = useState(false);

   useEffect(() => {
      if (!_.isEqual(data, props.data)) {
         setData(props.data);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.data]);

   function downloadCorrectiveActionPdf(actionId, actionType) {
      if (downLoading === false) {
         setDownLoading(true);
         let correctiveSearchCriteria = {
            ActionId: actionId,
            ActionType: actionType
         }
         api
            .postDownloadBinary(
               `Report/CorrectiveAction`,
               correctiveSearchCriteria,
               constants.MIME_TYPES.pdf,
               "Corrective_Action_Report_" + dateHelpers.getDateStringForReportName() + ".pdf",
               "There was an error downloading the Corrective Action report."
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setDownLoading(false));
      }
   }

   return (
      <>
         <Row className="align-items-center">
            <Col className="transparent-background">
               <Pager
                  callBack={props.pagerCallback}
                  sizeCallback={props.sizeCallback ? props.sizeCallback : null}
                  pageNumber={props.pageNumber}
                  pageSize={props.pageSize ? props.pageSize : null}
                  totalPages={props.totalPages}
                  disabled={props.downloading}
               />
            </Col>
            <Col className="transparent-background">
               {data && data.length && props.exportXlsxCallback
                  ? (<Button
                     title="Download as .xlsx"
                     className="shredButtonExcel float-end ms-2"
                     onClick={props.exportXlsxCallback}
                     disabled={props.downloading}
                  >
                     <FontAwesomeIcon icon="file-excel" size="lg" />
                  </Button>)
                  : null
               }
               {data && data.length && props.exportPdfCallback
                  ? (<Button
                     title="Download as .pdf"
                     className="shredButton float-end"
                     onClick={props.exportPdfCallback}
                     disabled={props.downloading}
                  >
                     <FontAwesomeIcon icon="file-pdf" size="lg" />
                  </Button>)
                  : null
               }
            </Col>
         </Row>
         <Table size="sm" className="data-table">
            <thead className="table-header">
               <tr>
                  <th style={{ width: "7%" }}>
                     <SortHeader
                        displayName="Id"
                        field="actionId"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "actionId"}
                        callback={props.sortCallback}
                     />
                  </th>
                  {props.calledFromSalesDashboard
                     ? <th style={{ width: "7%" }}>
                        <SortHeader
                           displayName="Customer"
                           field="customerVendorName"
                           sortDirection={props.sortDirection}
                           sorted={props.sortField === "customerVendorName"}
                           callback={props.sortCallback}
                        />
                     </th>
                     : null
                  }
                  <th style={{ width: "7%" }}>
                     <SortHeader
                        displayName="Open Date"
                        field="createdDate"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "createdDate"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "5%" }}>
                     <SortHeader
                        displayName="Status"
                        field="actionStatus"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "actionStatus"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "7%" }}>
                     <SortHeader
                        displayName="Action Type"
                        field="actionType"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "actionType"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "7%" }}>
                     <SortHeader
                        displayName="Problem Type"
                        field="problemTypeDescription"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "problemTypeDescription"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "25%" }}>
                     <SortHeader
                        displayName="Description"
                        field="shortDescription"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "shortDescription"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "7%" }}>
                     <SortHeader
                        displayName="Item"
                        field="itemNumber"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "itemNumber"}
                        callback={props.sortCallback}
                     />
                  </th>
                  {/* {userCtx && (userCtx.currentUser.isAPUCS || helpers.hasRoleId(constants.ROLE_IDS.QualityEdit)) &&
                    (<th style={{ width: "2%" }}></th>)
                  } */}
                  <th style={{ width: "2%" }}></th>
               </tr>
            </thead>
            <tbody>
               {data && data.length ? _.map(data, (c, index) => (
                  <tr key={index} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                     <td className="data-cell">{c.displayId}</td>
                     {props.calledFromSalesDashboard
                        ? <td className="data-cell">{c.customerVendorName}</td>
                        : null
                     }
                     <td className="data-cell">{new Date(c.createdDate).toLocaleDateString()}</td>
                     <td className="data-cell">{actionStatuses[c.actionStatus]}</td>
                     <td className="data-cell">{actionTypes[c.actionType]}</td>
                     <td className="data-cell">{c.problemTypeDescription}</td>
                     <td>{c.shortDescription}</td>
                     {props.calledFromSalesDashboard
                        ? <ItemDropdownMenu
                           itemNumber={c.itemNumber}
                           itemDescription={c.itemWithDescription}
                           attachmentCount={c.itemAttachmentCount}
                        // customerId={c.customerId}
                        />
                        : <td className="data-cell">{c.itemWithDescription}</td>
                     }
                     {/* {userCtx && (userCtx.currentUser.isAPUCS || helpers.hasRoleId(constants.ROLE_IDS.QualityEdit)) &&
                         (<td className="data-cell">
                           <Button
                             className="icon-button me-1"
                             title={"Edit line"}
                             color={"info"}
                           >
                             <FontAwesomeIcon className="whiteIcon" icon={"edit"} />
                           </Button>
                         </td>)
                       } */}
                     <td className="data-cell">
                        <Button
                           className="shredLink transparent-background"
                           children="Print"
                           onClick={() => downloadCorrectiveActionPdf(c.actionId, c.actionType)}
                        />
                     </td>
                  </tr>
               )) : null}
            </tbody>
            <tfoot className="table-footer">
               <tr>
                  <td colSpan="9" />
               </tr>
            </tfoot>
         </Table>
      </>
   );
}